// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3GxyS","title":"Contact_title__Lz79Q"};